import React, { useMemo } from "react";
import { NavLink } from "react-router-dom";
import Button from "./button";
import Deco from "./Deco";

const SVG_NAMES = ["three"];

export default function Footer() {
  const contactEmail = "casey@alvarezbranding.com";
  const randomSvg = useMemo(
    () => SVG_NAMES[Math.floor(Math.random() * SVG_NAMES.length)],
    []
  );
  return (
    <footer className="site-footer">
      <Deco name="four" className="deco-footer deco-footer--left" />
      <Deco name="five" className="deco-footer deco-footer--right" />
      <div className="footer-logo" aria-hidden="true">
        <img
          className="footer-logo__svg"
          src={`${process.env.PUBLIC_URL}/style-svgs/${randomSvg}.svg`}
          alt=""
        />
      </div>

      <div className="container footer-inner">
        <div className="footer-grid">
          <div className="footer-col">
            <div className="footer-brand">Alvarez Branding Co.</div>
            <p className="footer-text">
              Branding, websites, and design systems that help growing businesses
              look like leaders.
            </p>
          </div>

          <div className="footer-col">
            <div className="footer-heading">Explore</div>
            <nav aria-label="Footer navigation">
              <ul className="footer-links">
                <li>
                  <NavLink to="/">Home</NavLink>
                </li>
                <li>
                  <NavLink to="/work">Our Work</NavLink>
                </li>
                <li>
                  <NavLink to="/photography">Photography</NavLink>
                </li>
                <li>
                  <NavLink to="/about">About</NavLink>
                </li>
                <li>
                  <NavLink to="/contact">Contact</NavLink>
                </li>
              </ul>
            </nav>
          </div>

          <div className="footer-col">
            <div className="footer-heading">Get in touch</div>
            <div className="footer-text">
              <a className="footer-email" href={`mailto:${contactEmail}`}>
                {contactEmail}
              </a>
            </div>
            <div className="footer-cta">
              <Button to="/contact" type="primary">
                Start a project
              </Button>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copyright-wrap">
            © {new Date().getFullYear()}, Alvarez Branding Co.
          </div>
        </div>
      </div>
    </footer>
  );
}

